import SettingsContent from '../Wrapper';
import RolesHome from './Index';
import RolesHeader from './RolesHeader';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/roles'),
      component: SettingsContent,
      props: {
        headerTitle: 'ROLES.HEADER',
        icon: 'people',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'roles_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'roles_list',
          component: RolesHome,
          components: {
            default: RolesHome,
            header: RolesHeader,
          },
          roles: ['administrator'],
        },
      ],
    },
  ],
};
